import { useEffect, useState } from 'react';

/**
 * 값이 delay(ms) 동안 안정될 때까지 갱신을 지연시킨다.
 * 검색어 입력 → 실시간 서버 조회 시 매 키입력마다 호출되는 것을 막기 위한 디바운스.
 */
export function useDebouncedValue<T>(value: T, delay = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);

  return debounced;
}
